import { createActions } from 'redux-actions';

import { PaymentTransaction } from '@models/PaymentTransaction';
import { Billing } from '@models/Billing';
import { CreatePaymentTransactionParams } from '@apis/PaymentTransactionApi';
import { GetBillingParams } from '@apis/BillingApi';
import { CancerQuote } from '@models/CancerQuote';
import { GetCancerQuoteParams } from '@apis/CancerQuoteApi';

export type State = {
  cancerQuote?: CancerQuote | null;
  billing?: Billing | null;
  paymentTransaction?: PaymentTransaction | null;
}

export type CancerQuoteFetchPayload = GetCancerQuoteParams;
export type BillingFetchPayload = GetBillingParams;
export type PaymentTransactionCreatePayload = CreatePaymentTransactionParams;
export type StateUpdatePayload = Partial<State>;

export const {
  cancerQuoteFetch,
  billingFetch,
  paymentTransactionCreate,
  stateUpdate,
} = createActions(
  'CANCER_QUOTE_FETCH',
  'BILLING_FETCH',
  'PAYMENT_TRANSACTION_CREATE',
  'STATE_UPDATE',
  {
    prefix: 'CANCER_QUOTE_PAYMENT_PAGE',
  },
);
